import { render, staticRenderFns } from "./SelectAsRadioField.vue?vue&type=template&id=5babe3f0&scoped=true&"
import script from "./SelectAsRadioField.vue?vue&type=script&lang=js&"
export * from "./SelectAsRadioField.vue?vue&type=script&lang=js&"
import style0 from "./SelectAsRadioField.vue?vue&type=style&index=0&id=5babe3f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5babe3f0",
  null
  
)

export default component.exports